<template>
  <router-view />
</template>

<script>
import { computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
export default {
  setup() {
    const siteData = reactive({
      title: `Mobile & Online Fundraising For Africa | M-Changa Africa`,
      description: `Fundraiser Portal | M-Changa Africa`,
    })
    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    })
  },
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
